import React, { Component } from 'react';

class ConnectForm extends Component {

    constructor (props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            phone: '',
            message: '',
            requestValid: false,
            formValid: false,
            errors: {},
            captcha: null
        }
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({[name]: value});
    }

    validate(){

        let errors = {};
        let hasError = false;
        let captchaAnswer = 2.5;

        // Captcha
        if(this.state.captcha.length <= 0) {
            errors.captcha = 'Please verify you are a hunman.';
            hasError = true;
        } else if(this.state.captcha != captchaAnswer){
            errors.captcha = 'Please answer the question correctly.';
            hasError = true;
        }


        // Email
        if(this.state.email) {

            let emailValid = this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
            if(!emailValid) {
                errors.email = 'Not a valid email';
                hasError = true;
            }

        } else if(!this.state.email){
            errors.email = 'Email is required';
            hasError = true;
        }

        if(hasError){
            this.setState({errors:errors});
            return false;
        }
        return true;

    }

    submit(e){
        e.preventDefault();

        if(!this.validate()) return;

        this.props.onSubmit(this.state);
    }

 render () {

     let emailStyles = 'form-field -half';
     if(this.state.errors.email) emailStyles += ' -error';

     let messageStyles = 'form-field';
     if(this.state.errors.message) messageStyles += ' -error';

     let captchaStyles = 'form-field';
     if(this.state.errors.captcha) captchaStyles += ' -error';

     return (
     <form className="groups-form tcc-webcomponent-form" onSubmit={(e) => this.submit(e)}>

       <div className={emailStyles}>

         <label htmlFor="email">Email</label>

         <input type="email" placeholder="Email" required className="form-control" name="email" onChange={(event) => this.handleUserInput(event)}/>

         {(this.state.errors.email && (<span className="error">{this.state.errors.email}</span>))}

       </div>

       <div className="form-field -half">

         <label htmlFor="name">Name</label>

         <input type="text" placeholder="Your name" required className="form-control" name="name" onChange={(event) => this.handleUserInput(event)}/>

       </div>

       <div className="form-field -half">

         <label htmlFor="phone">Phone</label>

         <input type="text" placeholder="Phone" className="form-control" name="phone" onChange={(event) => this.handleUserInput(event)}/>

       </div>

       <div className={messageStyles}>

         <label htmlFor="message">Message</label>

         <textarea name="message" placeholder="Message" className="form-control" onChange={(event) => this.handleUserInput(event)}></textarea>
         {(this.state.errors.message && (<span className="error">{this.state.errors.message}</span>))}

       </div>

       <div className={captchaStyles}>

         <label htmlFor="phone">Spam Filter: What is 10 - 7.5?</label>

         <input type="text" placeholder="Not a robot test" className="form-control" name="captcha" onChange={(event) => this.handleUserInput(event)} required/>
         {(this.state.errors.captcha && (<span className="error">{this.state.errors.captcha}</span>))}

       </div>

       <div className="form-field"><button type="submit" className="button-primary">Submit</button></div>

     </form>
   )
 }
}
export default ConnectForm;
